import {ChevronDown, ChevronRight} from "lucide-react";
import {useState} from "react";
import {SectionItem} from "~/components/SectionItem";

type SectionType = {
    title: string,
    children: Item[],
}

export function Section({title, children}:SectionType) {
    const [show, setShow] = useState(true);
    const toggle = () => {
        setShow((prev) => !prev)
    }

    if (!(children?.length > 0)) {
        return null
    }

    return (
        <div>
            <div className={"mt-10"}>{/*SPACE*/}</div>
            <div className="flex">
                <div className={"bg-[#489C8C] inline-block rounded-l-lg py-2 px-3 font-bold text-white text-sm md:text-xl cursor-pointer"} onClick={toggle}>
                    {show ?
                        <ChevronDown size={20} strokeWidth={3} className={"inline"} /> :
                        <ChevronRight size={20} strokeWidth={3} className={"inline"} />}
                </div>
                <div className={"bg-[#489C8C] inline-block rounded-r py-2 px-3 font-bold text-white text-sm md:text-xl -ms-px cursor-pointer"} onClick={toggle}>{title}</div>
                <div className={"bg-[#489C8C] inline-block rounded-r py-2 px-3 font-bold text-white text-sm md:text-xl -ms-2 cursor-pointer skew-x-[10deg] h-[44px] w-[12px]"} onClick={toggle}></div>
            </div>
            <div className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl_grid-cols-4 2xl:grid-cols-4 gap-3"}>
                { show && <>
                    {children.sort((a, b) => {
                        return a.OrdNr - b.OrdNr
                    }).map((item) => (
                        <SectionItem item={item} key={item.Id} />
                    ))}
                </>}
            </div>
        </div>
    )
}